// extracted by mini-css-extract-plugin
export default {"textWrap":"MaxtropyAbilityList_textWrap__5aV+S","tagDisplay":"MaxtropyAbilityList_tagDisplay__cjSoy"};